import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1785c86e: FaireBrandEntity = {
  token: "b_1785c86e",
  type: "brand",
  name: "Top Trenz Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/98b3db9aaaaee03e0ee7d389413b9146bc29221ab2dce9e1655e53c0977f3274.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0187feb85fe7f61d93f1ec8deb37adda823148706f0762cd41d1de916e479dea.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/98b3db9aaaaee03e0ee7d389413b9146bc29221ab2dce9e1655e53c0977f3274.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0187feb85fe7f61d93f1ec8deb37adda823148706f0762cd41d1de916e479dea.jpeg",
  location: "ronkonkoma, NY, USA",
  minimumOrderDollars: 149,
  rating: 4.9,
  reviewCount: 173,
  isTopShop: true,
  isInsider: true,
  description:
    "\nTop Trenz, Inc has been in business for over 25 years and focusing on small business customers to keep the line exciting and hard to find in the industry. Our New York office/warehouse/showroom is located in NY and was founded in 1999. In addition, we have numerous other showrooms in the United States including New York, Texas, Las Vegas, Los Angeles,  New England and Atlanta. We are on top of the latest trends and carry a complete line of fashion accessories, hair accessories, toys,  novelties, apparel, bags, and pillows. We can assure our customers that we will continue to keep on top of what is hot for the upcoming seasons and deliver great customer service to our customers with a high-quality product that can't be found in the mass market to give our product line exclusivity!",
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:40:33.230Z",
    importedBy: "entity-db-cli",
  },
};
